<template>
  <div>
    <van-nav-bar :right-text="username" left-arrow left-text="返回" title="绑定容器" @click-left="onClickLeft" @click-right="goIndex()">
    </van-nav-bar>
    <van-col span="12">
      <van-row gutter="10" style="height: 300px">
        <van-field v-model="data0.container.no" error label="箱号" readonly style="font-size: large" @click="open(data0)" />
        <van-field v-model="data0.pickingOrder.no" label="拣货单号" readonly style="font-size: large" />
        <van-field label="箱子顺序" readonly style="font-size: large" value="1号箱" />
      </van-row>
      <van-row gutter="10" style="height: 300px">
        <van-field v-model="data2.container.no" error label="箱号" readonly style="font-size: large" @click="open(data2)" />
        <van-field v-model="data2.pickingOrder.no" label="拣货单号" readonly style="font-size: large" />
        <van-field label="箱子顺序" readonly style="font-size: large" value="3号箱" />
      </van-row>
    </van-col>
    <van-col span="12">
      <van-row gutter="20" style="height: 300px">
        <van-field v-model="data1.container.no" error label="箱号" readonly style="font-size: large" @click="open(data1)" />
        <van-field v-model="data1.pickingOrder.no" label="拣货单号" readonly style="font-size: large" />
        <van-field label="箱子顺序" readonly style="font-size: large" value="2号箱" />
      </van-row>
      <van-row gutter="20" style="height: 300px">
        <van-field v-model="data3.container.no" error label="箱号" readonly style="font-size: large" @click="open(data3)" />
        <van-field v-model="data3.pickingOrder.no" label="拣货单号" readonly style="font-size: large" />
        <van-field label="箱子顺序" readonly style="font-size: large" value="4号箱" />
      </van-row>
    </van-col>
    <van-tabbar fixed placeholder>
      <van-tabbar-item align="center">
        <van-button :loading="loading" block round style="margin: 8px;width: 200px" type="primary" @click="confirm">确认</van-button>
      </van-tabbar-item>
    </van-tabbar>
    <van-dialog v-model="show" :before-close="bind" show-cancel-button style="width:400px" title="绑定容器">
      <van-field v-model="item.container.no" autofocus label="容器号" style="font-size: large" />
    </van-dialog>
  </div>
</template>
<script>
  import api from '@/api'
  import { findAll, post } from '@/api/Api'
  import { getUser, getUserId, removeNullValues } from '@/pdaView/utils'
  import { Toast } from 'vant'

  export default {
    name: 'Binding',
    components: {},
    data() {
      return {
        loading: false,
        username: getUser().name,
        text: '',
        show: false,
        taskGroup: this.$route.params.taskGroup,
        data0: { index: 1, pickingOrder: { id: null, no: '' }, container: { no: '' } },
        data1: { index: 2, pickingOrder: { id: null, no: '' }, container: { no: '' } },
        data2: { index: 3, pickingOrder: { id: null, no: '' }, container: { no: '' } },
        data3: { index: 4, pickingOrder: { id: null, no: '' }, container: { no: '' } },
        item: { pickingOrder: { id: null, no: '' }, container: { no: '' } }
      }
    },
    activated() {
      this.refresh()
    },
    methods: {
      goIndex() {
        this.$router.push({ name: 'PadIndex' })
      },
      onClickLeft() {
        this.$router.back()
      },
      open(item) {
        if (!item.container.no) {
          this.show = true
          this.item = item
        }
      },
      refresh() {
        if (!this.taskGroup) {
          return
        }
        this.loading = true
        const args = {
          'taskGroup': this.taskGroup,
          device: false,
          'user.id': getUserId()
        }
        findAll('pickingOrderContainerFactory', args).then(res => {
          if (res.success) {
            if (res.result.length === 0) {
              Toast('任务分组没有对应的拣货单数据')
              return
            }
            Object.assign(this.data0, removeNullValues(res.result[0]))
            Object.assign(this.data1, removeNullValues(res.result[1]))
            Object.assign(this.data2, removeNullValues(res.result[2]))
            Object.assign(this.data3, removeNullValues(res.result[3]))
          }
        }).finally(() => this.loading = false)
      },
      bind(action, done) {
        if (action === 'confirm') {
          const args = {
            'pickingOrder.id': this.item.pickingOrder.id,
            'container.no': this.item.container.no
          }
          if (this.item.container.no) {
            post(api.pickingBind, { type: 'padBinder' }, args).then(res => {
              if (res.success) {
                Toast('绑定成功！')
                this.item = { pickingOrder: { id: null, no: '' }, container: { no: '' } }
              } else {
                this.item.container.no = ''
              }
            })
          } else {
            Toast('请输入容器号！！')
          }
        } else if (action === 'cancel') {
          this.item.container.no = ''
        }
        done()
      },
      confirm() {
        const containers = [this.data0, this.data1, this.data2, this.data3]
        const item = containers.find(item => item.container.no === '' && item.pickingOrder.no !== '')
        if (item === undefined) {
          this.$router.push({ name: 'Picking', params: { taskGroup: this.taskGroup, containers: containers } })
        } else {
          Toast('拣货单 '.concat(item.pickingOrder.no).concat(' 未绑定容器'))
        }
      }
    }
  }
</script>